import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SeasonBadge } from "@/components/site/SeasonCalendar";
import { seasonStatus } from "@/lib/site";

export const ProductCard = ({ product, large = false }) => (
  <Link
    to={`/products/${product.slug}`}
    data-testid={`product-card-${product.slug}`}
    className="group relative flex flex-col rounded-lg border border-stone-200 bg-white overflow-hidden hover:-translate-y-1 transition-transform duration-300"
  >
    <div className={`overflow-hidden ${large ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
      <img src={product.image} alt={product.name} loading="lazy"
        className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
    </div>
    <div className="p-6 md:p-8 flex flex-col gap-3 flex-1">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="text-xl lg:text-2xl font-semibold text-stone-900">{product.name}</h3>
          <p className="text-sm text-stone-500">{product.variety}</p>
        </div>
        <ArrowUpRight className="h-5 w-5 text-stone-400 group-hover:text-emerald-900 transition-colors" />
      </div>
      <p className="text-sm text-stone-600 leading-relaxed">{product.short}</p>
      <div className="mt-auto pt-2 flex flex-wrap items-center gap-2">
        <SeasonBadge status={seasonStatus(product)} testid={`product-card-status-${product.slug}`} />
        <span className="text-xs text-stone-500">MOQ {product.moq}</span>
      </div>
    </div>
  </Link>
);
